"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var _ThemeHelper = require("../Utilities/ThemeHelper");

var styles = (0, _ThemeHelper.createStyles)(function (theme) {
  return {
    root: {
      display: "inline-flex",
      verticalAlign: "middle"
    },
    standardButtonDropDown: {},
    secondaryButton: {
      justifyContent: "flex-end"
    },
    standardArrowButton: {
      borderRadius: 0,
      padding: theme.spacing(1.38, 1)
    },
    primaryArrow: {
      borderRadius: 0,
      padding: theme.spacing(1.38, 1)
    },
    buttonMenu: {
      borderRadius: "0 0 2px 2px"
    },
    itemWrap: {
      padding: 0
    },
    fullWidth: {
      width: "100%"
    },
    menuItem: {
      justifyContent: "flex-end"
    },
    menuButtonRoot: {
      backgroundColor: theme.palette.grey[300],
      color: theme.palette.getContrastText(theme.palette.grey[300]),
      borderLeft: "1px solid " + theme.palette.divider
    },
    disabled: {
      backgroundColor: theme.palette.action.disabledBackground
    },
    primary: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText
    },
    secondary: {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.secondary.contrastText
    },
    menuButton: {
      color: "inherit",
      borderRadius: 0
    },
    inherit: {
      color: "inherit"
    }
  };
});
exports.styles = styles;